/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { ILabDepartment } from 'app/shared/model/lab-department.model';

export interface ILabDepartmentItem {
  id?: string;
  active?: boolean | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  cursor?: number;
  lcTestItem?: ILabTestItem | null;
  department?: ILabDepartment | null;
}

export const defaultValue: Readonly<ILabDepartmentItem> = {
  active: false,
};
